// src/modules/roles/Unauthorized/pages/UnauthorizedPage.tsx
import { useNavigate } from 'react-router-dom';
import styles from './Unauthorized.module.css';

function UnauthorizedPage() {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-2); // возвращаемся на две страницы назад
  };

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <h1 className={styles.title}>Недостаточно прав доступа</h1>
        <p className={styles.message}>
          У вас нет разрешения на просмотр данной страницы.
        </p>
        <button className={styles.button} onClick={handleGoBack}>
          Вернуться
        </button>
      </div>
    </div>
  );
}

export default UnauthorizedPage;